// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile-wrapper .header-container {
  width: 100%;
}
.user-profile-wrapper .user-profile-container {
  width: 45% !important;
}
.user-profile-wrapper .footer-container .button-container {
  margin: 1px !important;
  width: 80% !important;
}

@media (min-width: 370px) and (max-width: 635px) {
  .user-profile-wrapper .user-profile-container {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/user-profile/style.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AAEE;EACE,qBAAA;AAAJ;AAII;EACE,sBAAA;EACA,qBAAA;AAFN;;AAOA;EAEI;IACE,sBAAA;EALJ;AACF","sourcesContent":[".user-profile-wrapper {\n  .header-container {\n    width: 100%;\n  }\n  .user-profile-container {\n    width: 45% !important;\n  }\n\n  .footer-container{\n    .button-container{\n      margin: 1px !important;\n      width: 80% !important; \n    }\n  }\n}\n\n@media (min-width: 370px ) and (max-width:635px)  {\n  .user-profile-wrapper {\n    .user-profile-container {\n      width: 100% !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
